import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgV2ItemNa = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "17px",
	height: "16px",
	viewBox: "0 0 17 16",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "dib_checklist_Revised_07_04_No-Filling",
			transform: "translate(-1333.000000, -789.000000)",
			fill: "currentColor",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("g", {
				id: "TitleCollapsed",
				transform: "translate(426.000000, 781.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Action-Buttons",
					transform: "translate(819.350515, 0.000000)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "times-octagon",
						transform: "translate(88.000000, 8.000000)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M15.5290448,4.69395712 L11.2748538,0.439766082 C10.994152,0.159064327 10.6136452,0 10.2175439,0 L5.75438596,0 C5.3582846,0 4.97777778,0.159064327 4.69707602,0.439766082 L0.439766082,4.69395712 C0.159064327,4.97465887 0,5.35516569 0,5.75126706 L0,10.214425 C0,10.6105263 0.159064327,10.9910331 0.439766082,11.2717349 L4.69707602,15.5290448 C4.97777778,15.8097466 5.3582846,15.9688109 5.75438596,15.9688109 L10.2175439,15.9688109 C10.6136452,15.9688109 10.994152,15.8097466 11.2748538,15.5290448 L15.5321637,11.2717349 C15.8128655,10.9910331 15.9719298,10.6105263 15.9719298,10.214425 L15.9719298,5.75438596 C15.9688109,5.35516569 15.8097466,4.97465887 15.5290448,4.69395712 Z M14.4717349,10.214425 L10.214425,14.4717349 L5.75438596,14.4717349 L1.49707602,10.214425 L1.49707602,5.75438596 L5.75438596,1.49707602 L10.2175439,1.49707602 L14.4717349,5.75438596 L14.4717349,10.214425 Z M11.1594542,10.4545809 L10.4545809,11.1594542 C10.3079922,11.3060429 10.0709552,11.3060429 9.92436647,11.1594542 L7.98440546,9.21949318 L6.04444444,11.1594542 C5.89785575,11.3060429 5.66081871,11.3060429 5.51423002,11.1594542 L4.80935673,10.4545809 C4.66276803,10.3079922 4.66276803,10.0709552 4.80935673,9.92436647 L6.74931774,7.98440546 L4.80935673,6.04444444 C4.66276803,5.89785575 4.66276803,5.66081871 4.80935673,5.51423002 L5.51423002,4.80935673 C5.66081871,4.66276803 5.89785575,4.66276803 6.04444444,4.80935673 L7.98440546,6.74931774 L9.92436647,4.80935673 C10.0709552,4.66276803 10.3079922,4.66276803 10.4545809,4.80935673 L11.1594542,5.51423002 C11.3060429,5.66081871 11.3060429,5.89785575 11.1594542,6.04444444 L9.21949318,7.98440546 L11.1594542,9.92436647 C11.3060429,10.0709552 11.3060429,10.3079922 11.1594542,10.4545809 Z",
							id: "Shape"
						})
					})
				})
			})
		})
	})
});
export default SvgV2ItemNa;
